<div class="container-fluid">
  <div class="styles-body">
    <div class="panel-body content-body-pages">
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <mat-icon>local_shipping</mat-icon>
          </div>
          <div class="header-text">
            <h1 class="page-title">{{ 'DeliveryMethods' | translate }}</h1>
            <p>{{ 'ManageDeliveryMethods' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="delivery-methods-management-container">
        <div class="left-section">
          <div class="delivery-methods-section">
            <div class="section-title">
              <span>{{ 'DeliveryMethods' | translate }}</span>
            </div>

            @if (isLoadingDeliveryMethods) {
              <div class="loading-delivery-methods">
                <div class="loading-spinner">
                  <mat-icon>refresh</mat-icon>
                </div>
                <p>{{ 'LoadingDeliveryMethods' | translate }}</p>
              </div>
            } @else {
              <div class="delivery-methods-grid">
                <div (click)="onCreateDeliveryMethodClicked()"
                     [ngClass]="{'selected': !selectedDeliveryMethod}"
                     class="delivery-method-item add-delivery-method-item">
                  <div class="delivery-method-icon">
                    <mat-icon>add</mat-icon>
                  </div>
                  <div class="delivery-method-title">{{ 'AddDeliveryMethod' | translate }}</div>
                </div>

                @for (deliveryMethod of deliveryMethods; track deliveryMethod.DeliveryMethodId) {
                  <div
                    [ngClass]="{'selected': selectedDeliveryMethod?.DeliveryMethodId === deliveryMethod.DeliveryMethodId}"
                    class="delivery-method-item">
                    <div (click)="onDeliveryMethodClick(deliveryMethod)"
                         class="delivery-method-content">
                      <div class="delivery-method-icon">
                        @if (deliveryMethod.Type === 'DELIVERY') {
                          <mat-icon>local_shipping</mat-icon>
                        } @else {
                          <mat-icon>store</mat-icon>
                        }
                      </div>
                      <div class="delivery-method-info">
                        <div class="delivery-method-title">{{ deliveryMethod.Title }}</div>
                        <div class="delivery-method-type">{{ getDeliveryMethodTypeTitle(deliveryMethod.Type) }}</div>
                        <div class="delivery-method-price">{{ deliveryMethod.Price | number }} ریال</div>
                        <div class="delivery-method-status">
                          @if (deliveryMethod.IsActive) {
                            <span class="status-active">{{ 'Active' | translate }}</span>
                          } @else {
                            <span class="status-inactive">{{ 'Inactive' | translate }}</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="delivery-method-actions">
                      <button (click)="onUpdateDeliveryMethodClicked(deliveryMethod); $event.stopPropagation()"
                              class="action-btn edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button (click)="onDeleteDeliveryMethodClicked(deliveryMethod); $event.stopPropagation()"
                              class="action-btn delete-btn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="right-section">
          <div class="delivery-method-details-section">
            <div class="section-title">
              <span>{{ getSelectedDeliveryMethodTitle() }}</span>
            </div>

            @if (selectedDeliveryMethod || !isEditing) {
              <div class="delivery-method-form">
                <form #deliveryMethodForm="ngForm"
                      (ngSubmit)="onSubmitDeliveryMethod()">
                  <!-- Delivery Method Configuration -->
                  <div class="form-section">
                    <h4>{{ 'DeliveryMethodConfiguration' | translate }}</h4>
                    <!-- Title and Price -->
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-input
                          [(value)]="editingDeliveryMethod.Title"
                          [required]="true"
                          [title]="'Title'"
                          [type]="'text'">
                        </app-frontend-input>
                      </div>
                      <div class="form-group">
                        <app-frontend-input
                          [(value)]="editingDeliveryMethod.Price"
                          [required]="true"
                          [title]="'Price'"
                          [type]="'number'">
                        </app-frontend-input>
                      </div>
                    </div>
                    <!-- Description and Type -->
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-input
                          [(value)]="editingDeliveryMethod.Description"
                          [required]="false"
                          [title]="'Description'"
                          [type]="'text'">
                        </app-frontend-input>
                      </div>
                      <div class="form-group">
                        <app-frontend-dropdown
                          (onSelected)="onTypeSelect($event)"
                          [displayKey]="'Title'"
                          [fieldName]="'Value'"
                          [isSearchable]="false"
                          [options]="typeOptions"
                          [required]="true"
                          [selectedOptions]="selectedType ? [selectedType] : []"
                          [title]="'Type'">
                        </app-frontend-dropdown>
                      </div>
                    </div>
                    <!-- Payment Methods -->
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-select (valueChange)="onPaymentMethodsChanged($event)"
                                             [(value)]="selectedPaymentMethodIds"
                                             [controller]="'paymentMethods'"
                                             [displayKey]="'Title'"
                                             [fieldName]="'PaymentMethodId'"
                                             [isMultiple]="true"
                                             [method]="'get'"
                                             [microservice]="Constant.FOOD_SHOP"
                                             [protocolMethod]="'POST'"
                                             [required]="false"
                                             [searchOnKey]="'Title'"
                                             [selectedOptions]="selectedPaymentMethods"
                                             [title]="'PaymentMethodAvailable'"
                                             [version]="'v1'"></app-frontend-select>
                      </div>
                      <div class="form-group">
                        <app-frontend-select [(value)]="branchIds"
                                             [controller]="'businesses'"
                                             [displayKey]="'Title'"
                                             [fieldName]="'BusinessId'"
                                             [isMultiple]="true"
                                             [method]="'getBranches'"
                                             [microservice]="Constant.getFoodShop()"
                                             [protocolMethod]="'POST'"
                                             [required]="false"
                                             [searchOnKey]="'Title'"
                                             [selectedOptions]="selectedBranches"
                                             [title]="'ProviderBranches'"
                                             [version]="'v1'"></app-frontend-select>
                        <span
                          style="color: red">*در صورت انتخاب نکردن شعبه برای تمامی شعبه ها در نظر گرفته می شود</span>
                      </div>
                    </div>
                    <!-- Is Active -->
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-check-box
                          [(value)]="editingDeliveryMethod.IsActive"
                          [title]="'IsActive'">
                        </app-frontend-check-box>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group">
                        <app-frontend-input
                          [(value)]="editingDeliveryMethod.Radius"
                          [required]="true"
                          [title]="'Radius'"
                          [type]="'number'">
                        </app-frontend-input>
                      </div>
                    </div>
                    <!-- Map and Radius -->
                    <div class="form-row">
                      <div class="form-group full-width">
                        <app-frontend-map [(latitudePointer)]="editingDeliveryMethod.Latitude"
                                          [(longitudePointer)]="editingDeliveryMethod.Longitude"
                                          [height]="'400px'"
                                          [isRadiusSelectionEnable]="true"
                                          [radius]="editingDeliveryMethod.Radius"
                                          [width]="'100%'"></app-frontend-map>
                      </div>
                    </div>
                  </div>
                  <!-- Form Actions -->
                  <div class="form-actions">
                    <app-frontend-button
                      (onSubmit)="onSubmitDeliveryMethod()"
                      [Image]="true"
                      [class]="'card-green'"
                      [disabled]="!deliveryMethodForm.valid || isSubmitting"
                      [src]="'icons/tick-square.svg'"
                      [title]="isEditing ? 'Update' : 'Create'"
                      [validationRequired]="true">
                    </app-frontend-button>
                    <app-frontend-button
                      (click)="onCancelEdit()"
                      [Image]="true"
                      [class]="'card-yellow'"
                      [disabled]="false"
                      [src]="'icons/close-square.svg'"
                      [title]="'Cancel'">
                    </app-frontend-button>
                  </div>
                </form>
              </div>
            } @else {
              <div class="no-delivery-method-selected">
                <div class="no-delivery-method-icon">
                  <mat-icon>local_shipping</mat-icon>
                </div>
                <div class="no-delivery-method-content">
                  <h4>{{ 'SelectDeliveryMethod' | translate }}</h4>
                  <p>{{ 'SelectDeliveryMethodToViewDetails' | translate }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
